import React, { useState } from "react";
import "../../styles/terminal.css";
import UtilBar from "../../components/terminal/UtilBar.jsx";
import TabBar from "../../components/terminal/TabBar.jsx";
import OverviewScreen from "../overview-terminal/OverviewScreen.jsx";
import PayScreen from "../pay-terminal/PayScreen.jsx";
import ReceiveScreen from "../receive-terminal/ReceiveScreen.jsx";
import TreasuryScreen from "../treasury-terminal/TreasuryScreen.jsx";

/* TerminalShell — top-level frame for the Bloomberg-style redesign.
   Mounted at /dashboard/terminal so it lives alongside the legacy
   /dashboard chrome until the redesign is signed off. All four tabs
   render the new aesthetic against mock data; each pane consumes
   its data via props so wiring to backend §A–§D is one-line per
   pane (replace the mock import with the API call in the screen
   parent). */

const TABS = [
  { id: "overview", label: "OVERVIEW", kbd: "1" },
  { id: "pay",      label: "PAY",      kbd: "2" },
  { id: "receive",  label: "RECEIVE",  kbd: "3" },
  { id: "treasury", label: "TREASURY", kbd: "4" },
];

export default function TerminalShell({ config = {}, token, onSignOut, onSettings, onCards }) {
  const [tab, setTab] = useState("overview");

  /* Tenant + user identity for the top frame. The redesign was
     showing only the generic BLOX·TREASURY wordmark; per client
     feedback both the COMPANY name and the USER name now sit
     prominently in the UtilBar across every terminal page. */
  const toTitleCase = (s) => (s || "").trim().split(/\s+/).filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(" ");
  const companyName = toTitleCase(
    config?.company_display_name || config?.company_name || ""
  );
  const userName = toTitleCase(
    [config?.fname || config?.first_name, config?.lname || config?.last_name]
      .filter(Boolean).join(" ")
  ) || config?.user_name || "";

  const accountLabel = config?.account_number ? `ACCT-${String(config.account_number).slice(-4)}` : "";
  const currentUserEmail = config?.email || "";

  return (
    <div className="term-root" style={{ overflow:"hidden", minHeight:"100vh" }}>
      <UtilBar
        companyName={companyName}
        userName={userName}
        userEmail={currentUserEmail}
        accountLabel={accountLabel}
        baseCurrency={config?.base_currency || "USD"}
        onSettings={onSettings}
        onCards={onCards}
        onSignOut={onSignOut}
      />
      <TabBar tabs={TABS} activeId={tab} onChange={setTab} />

      {tab === "overview" && <OverviewScreen token={token} />}
      {tab === "pay"      && <PayScreen      token={token} />}
      {tab === "receive"  && <ReceiveScreen  token={token} />}
      {tab === "treasury" && <TreasuryScreen token={token} currentUserEmail={currentUserEmail} />}
    </div>
  );
}
